import { useEffect, useRef, useState } from 'react'
import { DateTime } from 'luxon'

// check if the event state has changed to started
// or if the event end date has passed
// show & hide vote now button accordingly
// returns boolean of event open
const computeVotingOpen = (event: any, closeDate: any): boolean => {
  if (!event) return false
  const totalSecsLeftInEvent = DateTime.fromISO(closeDate).diffNow('seconds').get('seconds')
  return event.state === 'started' && totalSecsLeftInEvent > 0
}

export const useCheckVotingOpenStateChange = ({ event, fetchEvent, closeDate }: any) => {
  const [loadingEvent, setLoadingEvent] = useState(false)
  const [votingOpen, setVotingOpen] = useState(() => computeVotingOpen(event, closeDate))
  const eventRef = useRef(event)
  eventRef.current = event

  // check if event state has changed to started at scheduled event open time
  const checkVoteStarted = async () => {
    if (!fetchEvent) {
      return
    }
    if (eventRef.current.state === 'finalized') {
      const dateTime = DateTime.fromISO(eventRef.current.openDate)
      const diff = dateTime.diffNow('seconds').get('seconds')
      // fetch event from api to see if switched to started
      // try for up to 60 seconds after event open time, switches around 30
      if (!votingOpen && diff < 0 && diff >= -60 && !loadingEvent) {
        setLoadingEvent(true)
        await fetchEvent()
        setLoadingEvent(false)
      }
    }
  }

  const checkEventState = () => {
    if (event) {
      const dateTime = DateTime.fromISO(closeDate)
      const totalSecsLeftInEvent = dateTime.diffNow('seconds').get('seconds')
      if (totalSecsLeftInEvent < 0 && votingOpen) setVotingOpen(false)
      else if (eventRef.current.state === 'started' && !votingOpen && totalSecsLeftInEvent > 0) setVotingOpen(true)
      else if (eventRef.current.state !== 'started' && votingOpen) setVotingOpen(false)

      checkVoteStarted()
    }
  }

  useEffect(() => {
    setVotingOpen(computeVotingOpen(event, closeDate))
  }, [event?.state, closeDate])

  useEffect(() => {
    const interval = setInterval(checkEventState, 1000)
    return () => clearInterval(interval)
  }, [votingOpen, event])

  return { votingOpen }
}
